module.exports = __webpack_public_path__ + "static/media/logo-ai.1e2d2217.svg";